import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Image } from 'react-bootstrap';
import logoYec from '../../assets/yec.svg';



export default function FooterHook() {

    useEffect(() => {
        
    }, []);



    return (
        <>
            <Container id="footer" fluid className='bg-light p-3'>
                <Container fluid className='text-end'>
                    <Link to='/license'>
                        <Image src={logoYec} width='80' />
                    </Link>
                </Container>
            </Container>
        </>
    )
};